export enum LIVE_STATE {
    CLOSE = 'close',
    PLAY = 'play',
    END = 'end show',
}

export const LIVE_DROPDOWN_REF_NAME = {
    DROP_DOM: 'dropDom',
    DROP_INVITE: 'dropInvite',
};
